import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className='p-5 center-item'>
      <div>
        <ol start='1' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span> Ibishingirwaho n’ibisabwa muri rusange</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            Mu gukoresha uru rubuga, wemeza ko wasomye kandi wumvise
            ibishingirwaho n’ibisabwa bijyanye na rwo
          </li>
          <li>
            Ibishingirwaho n’ibisabwa mu gukoresha urubuga bireba kandi
            bikubahirizwa n’urukoresha.
          </li>
          <li>Ibi bishingirwaho n’ibisabwa bishobora guhinduka.</li>
        </ul>
      </div>
      <div>
        <ol start='2' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Amakuru yerekeye umuntu ku giti cye n’umutekano</span>
            </strong>
          </li>
        </ol>
        <ul>
          <li>
            <p>
              Mu gukoresha uru rubuga na serivisi zarwo, wemereye mu buryo
              budateye urujijo kandi ku bushake bwawe Banki y’Amajyambere y’u
              Rwanda (BRD) gukusanya, gusuzuma (harimo no kuvuga mu ncamake) ,
              gutanga no kohereza ku bindi bigo amakuru bwite akwerekeye igihe
              icyo ari cyo cyose, hagamijwe gutanga, cyangwa kunoza serivisi
              cyangwa kwagura urubuga serivisi zitangwa zifashisha. Amakuru
              bwite akwerekeye na yo ashobora guhabwa ibindi bigo hagamijwe
              gusesengura niba ukwiriye gushyirwa mu bemerewe guhabwa inzu
              ziciriritse zitangwa n’Ikigo cy’Igihugu cy’Imiturire (RHA).
              Amakuru bwite akwerekeye ntazabikwa igihe kirengeje igikenewe
              kugira ngo uhabwe serivisi.{' '}
            </p>
          </li>
          <li>
            <p>
              Amakuru bwite akwerekeye azakoreshwa gusa hashingiwe ku byo
              watangiye uburenganzira
            </p>
          </li>
          <li>
            <p>
              Gutanga amakuru atari yo mu gihe uri gukoresha iyi serivisi bituma
              utongera kwemererwa muri gahunda cyangwa ukaba wakurikiranwa kuri
              icyo cyaha, cyangwa ugahanishwa ibyo bihano byombi icyarimwe.
            </p>
          </li>
          <li>
            <p>
              Cookies ni amakuru aturuka kuri murandasi akaguma kuri mudasobwa,
              uyikoresha akaba yakongera kuyabona mu gihe kiri imbere. Cookies
              zifashisha amakuru yihariye yavuye kuri murandasi ari kuri
              mudasobwa y’uyikoresha ku buryo ayo makuru yongera kuboneka ku
              mashini yohereza amakuru cyangwa ku zindi mashini zohereza
              amakuru. Aho winjirira ugiye gushaka amakuru ntihazashyirwaho
              Cookies z’umwimerere cyangwa Cookies zisa na yo ku gikoresho
              cy’umugenerwabikorwa ku buryo yagaragaza amakuru yerekeye imari
              y’umugenerwabikorwa, umugenerwabikorwa atabanje kubitangira
              uburenganzira mu buryo budateye urujijo mu nyandiko. Mu gukoresha
              iyi servivisi, uhaye BRD uburenganzira bwanditse bwo gukusanya no
              gushyira kuri mudasobwa yawe Cookies igihe bikenewe.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <ol start='3' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>
                Uburenganzira bwo guhererekanya amakuru bwite y’umuntu
              </span>
            </strong>
          </li>
        </ol>
        <ul>
          <li>
            <p>
              BRD izakira, yohereze, kandi ihererekanye amakuru bwite
              akwerekeyeho n’ibindi bigo, harimo na RHA (ikigo gishinzwe
              imiturire) n’ibindi bigo, ku bijyanye gusa n’ubusabe bwawe watanze
              muri gahunda yo kubona inzu iciriritse.{' '}
            </p>
          </li>
          <li>
            <p>
              Ku bijyanye na serivisi zitangwa n’urubuga Giriwawe, amakuru bwite
              akwerekeye ashobora no koherezwa hanze y’igihugu.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <ol start='4' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>
                Gusesa, guhagarika by’agateganyo no kugabanya imikoreshereze ya
                serivisi
              </span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <span>
              Hatitawe ku bigamijwe gukorwa, wemera ko dufite uburenganzira bwo
              guhindura, guhagarika by’agateganyo cyangwa kudakomeza gukoresha
              iyi serivisi igihe icyo ari cyo cyose kandi ntituzaryozwa
              ibyakwangirika cyangwa amakuru watakaza igihe duhisemo kubikora
              dutyo. Dushobora no guhitamo gushyiraho amabwiriza agabanya
              imikoreshereze ya serivisi zimwe na zimwe cyangwa serivisi zose
              dutanga.
            </span>
          </li>
          <li>
            <span>
              Uru rubuga ruseswa, ruhagarikwa by’agateganyo kandi rugabanya
              imikoreshereze ya serivisi hagendewe ku bushishozi bwa BRD.
              Imikorere cyangwa serivisi itangwa bishobora guhinduka by’igihe
              gito cyangwa burundu. Itangazo kuri ayo makuru ritangwa ku rubuga.
              BRD ntizirengera ibyakwangirika cyangwa amakuru watakaza ku makuru
              bwite akwerekeyeho.
            </span>
          </li>
        </ul>
      </div>
      <div>
        <ol start='5' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>
                Kudatanga garanti cyangwa ibyo wizeza abakoresha serivisi
              </span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <p>
            Sirivisi itangwa uko iri kandi hashingiwe ku buryo iri kuboneka. BRD
            ntitanga garanti cyangwa ngo ibizeze ko serivisi itazigera igira
            inenge n’imwe, cyangwa ko ibizatangwa muri iyi serivisi cyangwa
            binyuze muri iyi serivisi bizaba ari nta makemwa, bikwiye, byuzuye
            ku byerekeye icyo uyitezeho cyihariye.
          </p>
        </ul>
      </div>
      <div>
        <ol start='6' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Ikurwaho ry’uburyozwe no kugabanya uburyozwe</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <p>
              Uretse uburyozwe busobanuwe mu mategeko BRD yaba ikugomba, kandi
              budashobora gukurwaho cyangwa ngo buhindurwe ku bwumvikane hagati
              yawe na Banki, haba twebwe, cyangwa amashami yacu, abakozi bacu,
              abatanga serivisi cyangwa abaduhagarariye, ntibazaryozwa mu buryo
              ubwo ari bwo bwose icyakwangizwa cyangwa amakuru watakaza ayo ari
              yo yose kubera iyi serivisi, uburyo uyikoresha cyangwa uyizera,
              cyangwa amakuru ayo ari yo yose atangwa muri iyi serivisi cyangwa
              wabona kubera iyi serivisi. Wemera kandi ukumva ko wirengereye
              ingaruka zose zakomoka ku mikoreshereze y’iyi serivisi.
            </p>
          </li>
          <li>
            <p>
              BRD ntiryozwa ubukererwe wagira bwerekeye n’amakuru aturuka muri
              sisitemu n’imikoreshereze y’uru rubuga bitewe n’ibindi bigo bya
              Leta y’u Rwanda bitari mu nshingano za BRD.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <ol start='7' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Ubushobozi bwo gukora amasezerano</span>
            </strong>
          </li>
        </ol>
        <ul className='decimal_type'>
          <li>
            <p>
              Mu gukoresha iyi serivisi, wemeza (utanga isezerano ku buryo
              wakurikiranwa mu mategeko hashingiwe kuri iryo sezerano) ko ufite
              ubushobozi bwemewe n’amategeko bwo gukora amasezerano no
              kubahiriza ibikubiye mu masezerano
            </p>
          </li>
          <li>
            <p>
              Ugomba kuba nibura ufite imyaka 18 kugira ngo wemererwe gukoresha
              iyi serivisi.
            </p>
          </li>
          <li>
            <p>
              Mu gihe utizeye ko ufite ubushobozi bwemewe n’amategeko bwo gukora
              amasezerano, ugomba kwegera Banki (ukoresheje uburyo bushoboka),
              noneho BRD igashobora kuguha aya makuru mbere y’uko ukomeza
              gukoresha iyi serivisi.
            </p>
          </li>
        </ul>
      </div>
      <div>
        <ol start='8' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>
                Kutubahiriza/Kunanirwa kubahiriza ibi bishingirwaho n’ibisabwa
              </span>
            </strong>
          </li>
        </ol>
        <ol className='decimal_type'>
          <li>
            <p>
              Iyo utubahiriza ibi bishingirwaho n’ibisabwa, cyangwa iyo ukoresha
              iyi serivisi mu buryo butemewe n’amategeko cyangwa ukaba ugira uko
              ukorana n’iyi serivisi mu buryo butemewe n’amategeko, BRD izaba
              ifite uburenganzira bwo guhagarika burundu imikoranire yawe n’iyi
              serivisi nta nteguza uhawe, hatitawe ku bundi burenganzira waba
              ufite hashingiwe ku bikubiye muri ibi bishingirwaho n’ibisabwa
              cyangwa hashingiwe ku mategeko.{' '}
            </p>
          </li>
          <li>
            <p>
              Iyo uburenganzira bwawe bwo kubona iyi serivisi busheshwe nk’uko
              bisobanuye haruguru, wemeza mu buryo bwumvikana neza ko inshingano
              zaba zihari hagati yawe na Banki mu gihe cy’iseswa ry’amasezerano,
              nk’uko zikubiye mu bishingirwaho n’ibisabwa, ko bizakomeza
              kubahirizwa kugeza igihe inshingano zitarubahirizwa zizaba zimaze
              kubahirizwa.
            </p>
          </li>
        </ol>
      </div>
      <div>
        <ol start='9' style={{ marginBottom: '0in' }} type='1'>
          <li
            style={{
              marginTop: '0in',
              marginRight: '0in',
              marginBottom: '8.0pt',
              marginLeft: '0in',
              lineHeight: 'normal',
              fontSize: '22px',
              fontFamily: 'Calibri',
              textAlign: 'justify',
            }}
          >
            <strong>
              <span>Amategeko akurikizwa</span>
            </strong>
          </li>
        </ol>
        <ol className='decimal_type'>
          <li>
            <p>
              Ibi bishingirwaho n’ibisabwa bigengwa kandi bizasobanurwa
              hashingiwe ku mategeko ya Repubulika y’u Rwanda nta kureba
              ukuvuguruzanya kwaba kuri mu biteganywa n’amategeko. Imikoranire
              yose cyangwa ibikorwa byose byaba byarabaye hashingiwe kuri iyi
              serivisi bizubahiriza amategeko ya Repubulika y’u Rwanda.
            </p>
          </li>
          <li>
            <p>
              Amakimbirane ayo ari yo yose ashingiye ku bishingirwaho cyangwa
              inshingano zidashingiye ku masezerano izo ari zo zose biyakomokaho
              cyangwa bifitanye isano na yo ashyikirizwa gusa inkiko zo mu
              Rwanda iyo impande zombi zidashoboye kuyakemura ku bwumvikane
              binyuze mu buryo buhari bwo gukemura amakimbirane bukoreshwa na
              BRD.
            </p>
          </li>
          <li>
            <p>
              Ubuhuza bwose bubaye bujyanye n’ibi bishingirwaho n’ibisabwa
              bubera mu muhezo aho twe namwe tuzasabwa kugira ibanga amakuru
              yerekeye amakimbirane yashyikirijwe ubuhuza, imigendekere
              y’ubuhuza n’ibyabuvuyemo.
            </p>
          </li>
        </ol>
      </div>
      <p>
        <br />
      </p>
    </div>
  );
};

export default TermsAndConditions;
